module.exports = __webpack_public_path__ + "img/Andaluza-30-min.83d5d01b.jpg";